import { call, put } from 'redux-saga/effects';
import {
  getAncillaryList,
  getBillingCodeTypeList,
  getCategoryList,
  getDRGBreakdown,
  getDRGCodeCategory,
  getDRGcostallentity,
  getDRGProviderName,
  getDRGReportingEntityName,
  getFilteredDRGBillingCodes,
  getFilteredDRGBillingCodeType,
  getFilteredDRGHospitalList,
  getFilteredDRGListData,
  getFilteredDRGPayerList,
  getHospitalList,
  getLevel1DescList,
  getModifierList,
  getNpiList,
  getPayerList,
  getPayerPriceCompList,
  getPayerProcCountList,
  getProcedureNameList,
  getProceduresCatList,
  getStateMapDataList,
  getRegionalMapDataList,
  getTopPrefEntityList,
  getOverviewDRGList,
  getOverviewCPTList,
  gettopProceduresL4,
  gettopProceduresNonPrefL4,
  getHistoricalRequests,
  placeReRequest,
  getFacilityScoreCardScores,
  getFacilityScoreCardNPIs,
  getProviderExtractFilters,
  getProviderExtractResults,
  getProviderExtractResultsCharts,
  getFilteredDRGAncillaryList
} from '../../services/ancillaryAndFacility';
import {
  setAncillaryList,
  setAncillaryListError,
  setBillingCodeTypeList,
  setBillingCodeTypeListError,
  setCategoryList,
  setCategoryListError,
  setDRGBreakdown,
  setDRGBreakdownError,
  setDRGCodeCategory,
  setDRGCodeCategoryError,
  setDRGCostAllEntity,
  setDRGCostAllEntityError,
  setDRGProviderName,
  setDRGProviderNameError,
  setDRGReportingEntityName,
  setDRGReportingEntityNameError,
  setFilterDRGBillingCodes,
  setFilterDRGBillingCodesError,
  setFilterDRGBillingCodeType,
  setFilterDRGBillingCodeTypeError,
  setFilterDRGHospitalList,
  setFilterDRGHospitalListError,
  setFilterDRGListData,
  setFilterDRGListDataError,
  setFilterDRGPayerList,
  setFilterDRGPayerListError,
  setHospitalList,
  setHospitalListError,
  setLevel1DescList,
  setLevel1DescListError,
  setModifierList,
  setModifierListError,
  setNpiList,
  setNpiListError,
  setPayerList,
  setPayerListError,
  setPayerPriceDiffList,
  setPayerPriceDiffListError,
  setPayerProcCountList,
  setPayerProcCountListError,
  setProcedureCategory,
  setProcedureCategoryError,
  setProcedureNameList,
  setProcedureNameListError,
  setStateMapDataList,
  setStateMapDataListError,
  setRegionalMapDataList,
  setRegionalMapDataListError,
  setTopPrefEntityList,
  setTopPrefEntityListError,
  setOverviewDrgListError,
  setOverviewDrgList,
  setOverviewCptList,
  setOverviewCptListError,
  setTopProcedureL4,
  setTopProcedureL4Error,
  setTopProcedureNonPrefL4,
  setTopProcedureNonPrefL4Error,
  setHistoricalRequests,
  setHistoricalRequestsError,
  setPlaceReRequest,
  setPlaceReRequestError,
  setFacilityScorecardScores,
  setFacilityScorecardScoresError,
  setFacilityScorecardNpis,
  setFacilityScorecardNpisError,
  setProviderExtractFilters,
  setProviderExtractFiltersError,
  setProviderExtractResult,
  setProviderExtractResultError,
  setProviderExtractResultCharts,
  setProviderExtractResultChartsError,
  setFilterDRGAncillaryList,
  setFilterDRGAncillaryListError
} from 'store/actions/ancillaryAndFacility';

export function* getPayerListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getPayerList, payload);
    if (response?.data) {
      yield put(setPayerList(response.data));
    }
  } catch (e) {
    yield put(setPayerListError(e));
  }
}

export function* getPayerProcCountListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getPayerProcCountList, payload);
    if (response?.data) {
      yield put(setPayerProcCountList(response.data));
    }
  } catch (e) {
    yield put(setPayerProcCountListError(e));
  }
}

export function* getCategoryListSaga(action) {
  try {
    const { payload } = action;

    const response = yield call(getCategoryList, payload);
    if (response?.data) {
      yield put(setCategoryList(response.data));
    }
  } catch (e) {
    yield put(setCategoryListError(e));
  }
}

export function* getHospitalListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getHospitalList, payload);
    if (response) {
      yield put(setHospitalList(response.data));
    }
  } catch (e) {
    yield put(setHospitalListError, e);
  }
}

export function* getAncillaryListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getAncillaryList, payload);
    if (response) {
      yield put(setAncillaryList(response.data));
    }
  } catch (e) {
    yield put(setAncillaryListError, e);
  }
}

export function* getProceduresCatListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getProceduresCatList, payload);
    if (response) {
      yield put(setProcedureCategory(response.data));
    }
  } catch (e) {
    yield put(setProcedureCategoryError, e);
  }
}

export function* getNpiListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getNpiList, payload);
    if (response) {
      yield put(setNpiList(response.data));
    }
  } catch (e) {
    yield put(setNpiListError, e);
  }
}

export function* getBillingCodeTypeListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getBillingCodeTypeList, payload);
    if (response) {
      yield put(setBillingCodeTypeList(response.data));
    }
  } catch (e) {
    yield put(setBillingCodeTypeListError, e);
  }
}

export function* getLevel1DescListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getLevel1DescList, payload);
    if (response) {
      yield put(setLevel1DescList(response.data));
    }
  } catch (e) {
    yield put(setLevel1DescListError, e);
  }
}

export function* getProcedureNameListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getProcedureNameList, payload);
    if (response) {
      yield put(setProcedureNameList(response.data));
    }
  } catch (e) {
    yield put(setProcedureNameListError, e);
  }
}

export function* getModifierListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getModifierList, payload);
    if (response) {
      yield put(setModifierList(response.data));
    }
  } catch (e) {
    yield put(setModifierListError, e);
  }
}

export function* getPayerPriceCompListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getPayerPriceCompList, payload);
    if (response) {
      yield put(setPayerPriceDiffList(response.data));
    }
  } catch (e) {
    yield put(setPayerPriceDiffListError, e);
  }
}
export function* getFilteredDRGHospitalListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getFilteredDRGHospitalList, payload);
    if (response) {
      yield put(setFilterDRGHospitalList(response.data));
    }
  } catch (e) {
    yield put(setFilterDRGHospitalListError, e);
  }
}

export function* getFilteredDRGAncillaryListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getFilteredDRGAncillaryList, payload);
    if (response) {
      yield put(setFilterDRGAncillaryList(response.data));
    }
  } catch (e) {
    yield put(setFilterDRGAncillaryListError, e);
  }
}

export function* getFilteredDRGPayerListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getFilteredDRGPayerList, payload);
    if (response) {
      yield put(setFilterDRGPayerList(response.data));
    }
  } catch (e) {
    yield put(setFilterDRGPayerListError, e);
  }
}

export function* getFilteredDRGBillingCodeTypeSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getFilteredDRGBillingCodeType, payload);
    if (response) {
      yield put(setFilterDRGBillingCodeType(response.data));
    }
  } catch (e) {
    yield put(setFilterDRGBillingCodeTypeError, e);
  }
}

export function* getFilteredDRGBillingCodeSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getFilteredDRGBillingCodes, payload);
    if (response) {
      yield put(setFilterDRGBillingCodes(response.data));
    }
  } catch (e) {
    yield put(setFilterDRGBillingCodesError, e);
  }
}

export function* getFilteredDRGListDataSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getFilteredDRGListData, payload);
    if (response) {
      yield put(setFilterDRGListData(response.data));
    }
  } catch (e) {
    yield put(setFilterDRGListDataError, e);
  }
}

//DRG COST BREAKDOWN

export function* getDRGcostallentitySaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDRGcostallentity, payload);
    if (response) {
      yield put(setDRGCostAllEntity(response.data));
    }
  } catch (e) {
    yield put(setDRGCostAllEntityError, e);
  }
}
export function* getDRGProviderNameSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDRGProviderName, payload);
    if (response) {
      yield put(setDRGProviderName(response.data));
    }
  } catch (e) {
    yield put(setDRGProviderNameError, e);
  }
}

export function* getDRGCodeCategorySaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDRGCodeCategory, payload);
    if (response) {
      yield put(setDRGCodeCategory(response.data));
    }
  } catch (e) {
    yield put(setDRGCodeCategoryError, e);
  }
}

export function* getDRGReportingEntityNameSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDRGReportingEntityName, payload);
    if (response) {
      yield put(setDRGReportingEntityName(response.data));
    }
  } catch (e) {
    yield put(setDRGReportingEntityNameError, e);
  }
}

export function* getDRGBreakdownSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDRGBreakdown, payload);
    if (response) {
      yield put(setDRGBreakdown(response.data));
    }
  } catch (e) {
    yield put(setDRGBreakdownError, e);
  }
}

export function* getStateMapDataListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getStateMapDataList, payload);
    if (response) {
      yield put(setStateMapDataList(response.data));
    }
  } catch (e) {
    yield put(setStateMapDataListError, e);
  }
}

export function* getRegionalMapDataListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getRegionalMapDataList, payload);
    if (response) {
      yield put(setRegionalMapDataList(response.data));
    }
  } catch (e) {
    yield put(setRegionalMapDataListError, e);
  }
}

export function* getTopPrefEntityListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getTopPrefEntityList, payload);
    if (response) {
      yield put(setTopPrefEntityList(response.data));
    }
  } catch (e) {
    yield put(setTopPrefEntityListError, e);
  }
}

export function* getOverviewDRGListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getOverviewDRGList, payload);
    if (response) {
      yield put(setOverviewDrgList(response.data));
    }
  } catch (e) {
    yield put(setOverviewDrgListError, e);
  }
}

export function* getOverviewCPTListSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getOverviewCPTList, payload);
    if (response) {
      yield put(setOverviewCptList(response.data));
    }
  } catch (e) {
    yield put(setOverviewCptListError, e);
  }
}

export function* gettopProceduresL4Saga(action) {
  try {
    const { payload } = action;
    const response = yield call(gettopProceduresL4, payload);
    if (response) {
      yield put(setTopProcedureL4(response.data));
    }
  } catch (e) {
    yield put(setTopProcedureL4Error, e);
  }
}

export function* gettopProceduresNonPrefL4Saga(action) {
  try {
    const { payload } = action;
    const response = yield call(gettopProceduresNonPrefL4, payload);
    if (response) {
      yield put(setTopProcedureNonPrefL4(response.data));
    }
  } catch (e) {
    yield put(setTopProcedureNonPrefL4Error, e);
  }
}

export function* getHistoricalRequestsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getHistoricalRequests, payload);
    if (response) {
      yield put(setHistoricalRequests(response.data));
    }
  } catch (e) {
    yield put(setHistoricalRequestsError, e);
  }
}

export function* placeReRequestSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(placeReRequest, payload);
    if (response) {
      yield put(setPlaceReRequest(response.data));
    }
  } catch (e) {
    yield put(setPlaceReRequestError, e);
  }
}

export function* getFacilityScoreCardScoresSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getFacilityScoreCardScores, payload);
    if (response) {
      yield put(setFacilityScorecardScores(response.data));
    }
  } catch (e) {
    yield put(setFacilityScorecardScoresError, e);
  }
}

export function* getFacilityScoreCardNPIsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getFacilityScoreCardNPIs, payload);
    if (response) {
      yield put(setFacilityScorecardNpis(response.data));
    }
  } catch (e) {
    yield put(setFacilityScorecardNpisError, e);
  }
}

export function* getProviderExtractFiltersSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getProviderExtractFilters, payload);
    if (response) {
      yield put(setProviderExtractFilters(response.data));
    }
  } catch (e) {
    yield put(setProviderExtractFiltersError, e);
  }
}

export function* getProviderExtractResultsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getProviderExtractResults, payload);
    if (response) {
      yield put(setProviderExtractResult(response.data));
    }
  } catch (e) {
    yield put(setProviderExtractResultError, e);
  }
}

export function* getProviderExtractResultsChartsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getProviderExtractResultsCharts, payload);
    if (response) {
      yield put(setProviderExtractResultCharts(response.data));
    }
  } catch (e) {
    yield put(setProviderExtractResultChartsError, e);
  }
}
